import {RouteDefinition} from '../../../routes';
import {IntercomListScreen} from './IntercomListScreen';
import {IntercomEditScreen} from './IntercomEditScreen';

export const IntercomSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/intercom',
        component: IntercomListScreen,
    },
    {
        routerLink: '/settings/intercom/edit/:id',
        component: IntercomEditScreen,
    },
    {
        routerLink: '/settings/intercom/edit',
        component: IntercomEditScreen,
    },
];
